/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEnAu from '@angular/common/locales/en-AU';

(window as any)['CESIUM_BASE_URL'] = '/cesium/';

registerLocaleData(localeEnAu);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
